import React, {useEffect} from 'react'
import {PageHeader} from "../../../components/common/pageHeader/PageHeader";
import {useNavigate, useSearchParams} from "react-router-dom";
import {URL_QUESTIONS_CATEGORY_CREATE, URL_QUESTIONS_CREATE} from "../../../mock/page_urls";
import {Pagination} from "../../../components/common/pagination/Pagination";
import {useQuery} from "react-query";
import {LoaderSection} from "../../../components/sections/loader/Loader";
import {EmptySection} from "../../../components/sections/empty/Empty";
import {separateFormatter} from "../../../utils/separateFormatter";
import {KTIcon, useDebounce} from "../../../../_metronic/helpers";
import {getQuestions} from "../../../services/questionSvc";
import {QuestionCard} from "../../../components/common/questionCard/QuestionCard";

export const QuestionsPage = () => {

  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get("page") || "1", 10)
  const searchQuery = searchParams.get("search") || ""

  const debouncedSearch = useDebounce(searchQuery, 500);

  const {
    data: questionsData,
    isLoading: questionsIsLoading,
    refetch: refetchQuestions
  } = useQuery(["getQuestions", debouncedSearch, page], () => getQuestions({
    params: {
      page: page,
      page_size: 10,
      search: debouncedSearch
    }
  }))

  const pageDetails = {
    title: "Savol-Javoblar",
    desc: `Jami savol-javoblar soni: (${separateFormatter(questionsData?.total_items || 0, " ", "ta")})`,

    buttons: [
      {
        onClick: () => navigate(URL_QUESTIONS_CATEGORY_CREATE),
        text: "Kategoriya qo'shish",
        icon: "plus-square",
        className: "btn-light-primary"
      },
      {
        onClick: () => navigate(URL_QUESTIONS_CREATE),
        text: "Qo'shish",
        icon: "plus-square",
      }
    ]
  };

  const totalItems = questionsData?.total_items || 0;
  const itemsPerPage = questionsData?.page_size || 8;


  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchParams({page: "1", search: query});
  }

  useEffect(() => {
    if (debouncedSearch) {
      refetchQuestions();
    }
  }, [debouncedSearch, refetchQuestions]);

  return (
      <div>
        <PageHeader pageDetails={pageDetails}/>
        <div className={"d-flex flex-wrap justify-content-between align-items-center rounded py-1 mb-5"}>
          <div className={"w-100 w-100 w-md-250px"}>
            <div className="d-flex align-items-center position-relative my-1">
              <KTIcon iconName={"magnifier"} className={"fs-1 position-absolute ms-3"}/>
              <input value={searchQuery}
                     onChange={handleSearchChange} type="text" data-kt-user-table-filter="search"
                     className="form-control w-100 w-md-250px ps-12"
                     placeholder="Qidiruv..."/>
            </div>
          </div>
        </div>

        <div className={"mb-10 d-flex flex-column  gap-4 px-0 mx-0"}>
          {questionsIsLoading ? <LoaderSection height={"50vh"}/> : questionsData?.data?.length === 0 ?
              <EmptySection height={"50vh"}/> :
              <div className={"mb-5"}>
                {questionsData?.data?.map((question) => (
                    <QuestionCard key={question?.id} question={question} refetchQuestions={refetchQuestions}/>
                ))}
                <div className={"mt-10"}>
                  <Pagination
                      totalItems={totalItems}
                      itemsPerPage={itemsPerPage}
                  />
                </div>
              </div>
          }

        </div>

      </div>
  )
}
